import React, {useCallback, useEffect, useRef, useState} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../../services/remoting-service/RemotingService";

const AppointmentReferralSelector = ({value, onValueChange, onReferralSelect, inputStyle}) => {
    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState(value || "");
    const debounceRef = useRef();
    const autoCompleteRef = useRef(null);

    const fetchReferrals = useCallback((searchText) => {
        RemotingService.getRemoteCall(
            'api/appointment/referrals',
            {searchText},
            (referrals) => setSuggestions(referrals || []),
            undefined,
            false, // disable global loading overlay to prevent backdrop flicker
            false  // suppress auto messages for typeahead
        );
    }, []);

    const searchReferrals = useCallback((event) => {
        const query = event.query || '';
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => fetchReferrals(query), 200);
    }, [fetchReferrals]);

    useEffect(() => {
        fetchReferrals('');
    }, [fetchReferrals]);

    // Keep local input in sync if parent updates value (e.g., selecting a referral)
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    return (
        <AutoComplete
            ref={autoCompleteRef}
            value={inputValue}
            suggestions={suggestions}
            completeMethod={searchReferrals}
            field="doctorName"
            placeholder="Search referring doctor..."
            minLength={0}
            inputStyle={inputStyle || {width: "95%", padding: "5px 11px"}}
            inputClassName="AddModalAutoComplete"
            onFocus={() => {
                fetchReferrals(''); // ensure initial load on first click
                // trigger panel display using internal search with non-input source to allow empty query
                if (autoCompleteRef.current?.search) {
                    autoCompleteRef.current.search({}, '', 'focus');
                }
            }}
            onChange={(e) => {
                setInputValue(e.value);
                if (onValueChange) {
                    onValueChange(e.value);
                }
            }}
            onSelect={(e) => {
                const selectedName = e.value?.doctorName || "";
                setInputValue(selectedName);
                if (onValueChange) {
                    onValueChange(selectedName);
                }
                if (onReferralSelect) {
                    onReferralSelect(e.value);
                }
            }}
            itemTemplate={(referral) => (
                <div>
                    <div><strong>{referral.doctorName}</strong></div>
                    <div style={{fontSize: '0.85em', color: '#666'}}>
                        {referral.doctorLicence && <span>Licence: {referral.doctorLicence}</span>}
                        {referral.clinicName && <span> | Clinic: {referral.clinicName}</span>}
                        {!referral.clinicName && referral.specialty && <span> | {referral.specialty}</span>}
                        {referral.clinicId && <span> ({referral.clinicId})</span>}
                    </div>
                </div>
            )}
        />
    );
};

export default AppointmentReferralSelector;
